import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB4yBkTrcR4-USmSsCLqLQquoMlN21mpG4",
  authDomain: "photos-clone.firebaseapp.com",
  projectId: "photos-clone",
  storageBucket: "photos-clone.appspot.com",
  messagingSenderId: "499146813799",
  appId: "1:499146813799:web:7b6ef3b3a1faaa59c7ffc2",
};

initializeApp(firebaseConfig);

export const db = getFirestore();
export const storage = getStorage();
export const auth = getAuth();
export const provider = new GoogleAuthProvider();
